var LayoutPerspective = require('./../layout/LayoutPerspective');
var AppointmentInsuranceListWidget = require('./AppointmentInsuranceListWidget');
var wizardPerspectiveTemplate = require('./../wizard/wizardPerspectiveTemplate.hbs');
var PortalPerspectiveLayoutBehavior = require('./../PortalPerspectiveLayoutBehavior');
var AsideBehavior = require('./../aside/AsideBehavior');
var WizardAccessBehavior = require('./../wizard/WizardAccessBehavior');
var WizardPerspectiveBehavior = require('./../wizard/WizardPerspectiveBehavior');

var SecureMessageDataBehavior = require('./../secure-message/SecureMessageDataBehavior');
var AppointmentTypeDataBehavior = require('./../appointment-type/AppointmentTypeDataBehavior');

/**
 * Perspective to display the Appointment Insurance page
 *
 * @class AppointmentInsurancePerspective
 * @param options {Object} Options to configure this perspective.
 *   @param [options.patientVecnaId] {String} the vecna id of the current patient
 *   @param [options.appointmentExternalId] {String} the external id of the current appointment
 */
module.exports = LayoutPerspective.extend({
  template: wizardPerspectiveTemplate,
  moduleNamespace: 'appointmentInsurancePerspective',

  behaviors: {
    portalPerspectiveLayoutBehavior: PortalPerspectiveLayoutBehavior,
    asideBehavior: {
      behavior: AsideBehavior,
      asideHeaderMessageKey: 'appointment.insurance.aside.header',
      asideContentMessageKey: 'appointment.insurance.aside'
    },
    wizardAccessBehavior: WizardAccessBehavior,
    wizardPerspectiveBehavior: {
      behavior: WizardPerspectiveBehavior,
      pageName: WizardPerspectiveBehavior.PAGE_NAMES.INSURANCE
    },
    appointmentSecureMessage: {
      behavior: SecureMessageDataBehavior,
      returnSingleResult: true,
      ids: function(cache) {
        var appointmentExternalId = this.view._appointmentExternalId;
        if (!appointmentExternalId) {
          return { skipObjectRetrieval: true };
        }

        var patientVecnaId = this.view._patientVecnaId;
        var criteria = cache.getCriteriaForAppointmentIdAndExternalId(patientVecnaId, appointmentExternalId);
        return cache.fetchIdsByCriteria(criteria);
      }
    },
    appointmentType: {
      behavior: AppointmentTypeDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      ids: { property: 'behaviors.appointmentSecureMessage.data:appointmentDTO.externalAppointment.type'}
    }
  },

  /**
   * @method initialize
   * @override
   * @param options {Object} Options to configure this perspective.
   *   @param options.patientVecnaId {String} the vecna id of the current patient
   *   @param [options.appointmentExternalId] {String} the external id of the current appointment
   *   @param [options.regDate] {String} the date of the current appointments being preregistered for
   */
  initialize: function(options) {
    LayoutPerspective.prototype.initialize.apply(this);
    // These are set for the wizard behaviors.
    this._patientVecnaId = options.patientVecnaId;
    this._appointmentExternalId = options.appointmentExternalId;
    this._regDate = options.regDate;

    var appointmentInsuranceListWidget = new AppointmentInsuranceListWidget({
      patientVecnaId: options.patientVecnaId,
      appointmentExternalId: options.appointmentExternalId,
      regDate: options.regDate
    });

    this.getBehavior('wizardPerspectiveBehavior').setContentView(appointmentInsuranceListWidget);
  }
});
